import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { STATS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const Manifesto = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-cream text-forest py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-y-10 items-end mb-20">
          <div className="lg:col-span-7">
            <SectionLabel>{t("stats.title")}</SectionLabel>
            <Reveal delay={0.1}>
              <h2 className="font-display font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-2xl">
                {t("stats.subtitle")}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.2}>
              <p className="text-forest/70 text-base sm:text-lg font-light leading-relaxed">
                {t("services.turnkeyText")}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-forest/10 border border-forest/10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="group relative bg-cream p-8 lg:p-10 min-h-[220px] flex flex-col justify-between hover:bg-cream-2 transition-colors duration-500"
              data-testid={`stat-${s.key}`}
            >
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-2">
                0{i + 1}
              </span>
              <div>
                <div className="font-display font-light leading-none tracking-tight text-5xl sm:text-6xl lg:text-[4.5rem] text-forest group-hover:text-forest-deep transition-colors duration-500">
                  {s.value}
                </div>
                <div className="text-sm text-forest/60 mt-3 leading-snug">
                  {t(s.labelKey)}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
